import { useEffect, useState } from "react";
import { api } from "./api";

export const donate = {
  status: () => api.get("/donate/status").then(r => r.data),
  checkout: (payload) => api.post("/donate/checkout", payload).then(r => r.data),
  sessionStatus: (sid) => api.get(`/donate/checkout/status/${sid}`).then(r => r.data),
};

export function useDonateStatus() {
  const [s, setS] = useState({ configured: false, tiers: [], custom: { min: 1, max: 1000 } });
  useEffect(() => { donate.status().then(setS).catch(() => {}); }, []);
  return s;
}
